import {Context, useContext} from "react";

export const useContextStrict = <T>(context: Context<T | null>, _displayName?:string) : T => {
    const value = useContext(context)
    if(!value){
        throw new Error(`Context ${context.displayName ?? _displayName} is not provided`)
    }
    return value
}
